import styled from "styled-components";


export const ToggleLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 30px;
  height: 14px;
`;

export const ToggleInput = styled.input.attrs({ type: 'checkbox' })`
  display: none;
`;

export const ToggleSlider = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid ${props => (props.checked ? '#206600' : '#FF0000')};
  border-radius: 20px;
  cursor: pointer;
  transition: 0.4s;
`;

export const ToggleSliderBefore = styled.span`
  position: absolute;
  content: '';
  height: 10px;
  width: 10px;
  left: ${props => (props.checked ? '16px' : '2px')};
  bottom: 1px;
  background-color: ${props => (props.checked ? '#206600' : '#FF0000')};
  border-radius: 50%;
  transition: 0.4s;
`;
